// extracted by mini-css-extract-plugin
export default {"Tenant__profile":"SingleTenant_Tenant__profile__VeRBO","Tenant__photo":"SingleTenant_Tenant__photo__nVsRt","Tenant__info":"SingleTenant_Tenant__info__rvthE"};